<template>
  <table class="table" border="0">
    <thead>
      <tr>
        <th v-for="(col, i) in filteredColumns" :key="i">
          <button
            type="button"
            class="table__head-col"
            :class="{
              'table__head-col--sortable': col.sortable
            }"
            v-if="col.sortable"
          >
            <slot name="th" :col="col">{{ col | localeField("title") }}</slot>
            <span class="table__head-sort" v-if="col.sortable">
              <icon name="filter" />
            </span>
          </button>
          <div class="table__head-col" v-else>
            <slot name="th" :col="col">{{ col | localeField("title") }}</slot>
          </div>
        </th>
      </tr>
    </thead>
    <tbody v-if="rows.length">
      <template v-for="(row, i) in rows">
        <slot
          name="row-header"
          :row="row"
          :columns="filteredColumns"
          :i="i"
        ></slot>

        <tr :key="i">
          <template v-for="(col, j) in filteredColumns">
            <slot
              name="td"
              :row="row"
              :col="col"
              :i="i"
              :clickHandler="handleClick"
            >
              <td :key="j">
                <span @click="handleClick(i)">
                  {{ row[col.label] ? row[col.label] : "" }}
                </span>
              </td>
            </slot>
          </template>
        </tr>

        <tr :key="`${i}-new`" v-if="row.status === 'new' && showServiceDescr">
          <td colspan="8" style="padding: 0">
            <Notification icon="warning-border--no-color">
              {{ showDescriptionContractor(row.executor) }}
            </Notification>
          </td>
        </tr>

        <tr :key="`${i}-expand`" v-if="expanded === i || isServiceModal">
          <slot
            name="m-row"
            :row="row"
            :columns="columns"
            :i="i"
            v-if="!desktop"
          >
            <td :colspan="filteredColumns.length" class="table__expand"></td>
          </slot>
        </tr>

        <slot
          name="row-extension"
          :row="row"
          :columns="filteredColumns"
          :i="i"
        ></slot>
      </template>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="filteredColumns.length">
          {{ $t("services.empty") }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { Notification } from "@v2/shared/ui/components/notification";

export default {
  name: "Table",
  props: {
    columns: Array,
    rows: Array,
    showServiceDescr: {
      type: Boolean,
      default: false
    },
    isServiceModal: Boolean
  },
  data: () => ({
    expanded: null,
    desktop: window.innerWidth >= 740
  }),
  computed: {
    filteredColumns() {
      if (this.desktop) {
        return this.columns.filter(c => !c.hideDesktop);
      }
      return this.columns.filter(c => c.showMobile);
    }
  },
  methods: {
    handleClick(i) {
      this.expanded === i ? (this.expanded = null) : (this.expanded = i);
    },
    showDescriptionContractor(order) {
      return order.is_expocentr
        ? this.$t("services.orders.ordersContractorExpo")
        : this.$t("services.orders.ordersContractorAnother");
    }
  },
  components: { Notification }
};
</script>

<style lang="scss">
.table {
  width: 100%;
  background: var(--white);

  * {
    box-sizing: border-box;
  }

  &__form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    padding: 15px;
  }

  &__form-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    > span {
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
    }
  }

  tbody > tr:not(.blue):not(.light-blue):nth-child(odd) > td {
    background: var(--gray-light);
  }

  tr td {
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    border-bottom: 1px solid var(--gray-darker);

    .table-item-name {
      color: inherit;
      text-decoration: none;
    }
  }

  th {
    border-bottom: 1px solid var(--gray-darker);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    white-space: nowrap;
    color: var(--dark);
    text-align: left;
  }

  &__head-col {
    background: none;
    padding: 0;
    border: none;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    display: inline-block;
    height: 22px;
    color: var(--dark);
    vertical-align: bottom;

    &--sortable {
      cursor: pointer;
    }
  }

  &__head-sort {
    margin: auto auto auto 10px;
    height: 22px;
    display: inline-flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      color: var(--gray-dark);
    }
  }

  td,
  th {
    padding: 10px;
  }

  &__expand {
    background: var(--white) !important;
    padding: 0 !important;
  }

  &__open {
    background: none;
    padding: 0;
    cursor: pointer;
    margin: 0;
    border: none;
    width: 24px;
    height: 24px;
    display: none;
    align-items: center;
    justify-content: center;

    svg {
      width: 12px;
      height: 12px;
    }

    @media (max-width: 740px) {
      display: inline-flex;
    }
  }

  &__left-button {
    background: none;
    padding: 0;
    cursor: pointer;
    margin: 0 10px 0 0;
    border: none;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 12px;
      height: 12px;
    }
  }
}

.table-mobile {
  width: 100%;
  background: var(--white);

  * {
    box-sizing: border-box;
  }
}
</style>
